import {
  HJ_DICTIONARY_RECYCLE_VPV,
  HJ_MOVE_TO_ROW_FROM_RECYCLE,
  HJ_MOVE_TO_BASE_FROM_RECYCLE,
  HJ_MOVE_TO_COLUMN_FROM_RECYCLE,
} from '../hotjarConstants';
import { HOTJAR_TRACKING_ENABLED } from '../actions/urlTypes';

export const sendVPVHotjarEvent = action => {
  if (HOTJAR_TRACKING_ENABLED) {
    window.hj('vpv', action);
  }
};

export const getHotjarActionName = (page, action) => {
  switch (page) {
    case HJ_DICTIONARY_RECYCLE_VPV: {
      switch (action) {
        case 'RowsDataGrid': action = HJ_MOVE_TO_ROW_FROM_RECYCLE; break;
        case 'BasesDataGrid': action = HJ_MOVE_TO_BASE_FROM_RECYCLE; break;
        case 'ColumnsDataGrid': action = HJ_MOVE_TO_COLUMN_FROM_RECYCLE; break;
        default: action = ''; break;
      }
      return action;
    }
    default:
      return '';
  }
};
